import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from 'pages/AuthContext';

export const ProtectedRoute = ({ element: Element }) => {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  if (
    !isAuthenticated &&
    [
      '/psfcprojets',
      '/psfcpresfor',
      '/psfcpresforenqpromocontratenquetecreee',
      '/psfcpresforenqpromocontratenquetecreee/prefecture',
      '/PSFCPRESFORlivrablesIngenieurieSociauxSousPrefecture',
      '/resumecontrat',
      '/psfcpresforcreerenqute',
      '/psfcpresforenqpromocontrat',
      '/psfcpresforenqpromocontrataddcontrat',
      '/psfcpresforenqpromocontratupdatecontrat',
      '/Addcontratone',
      '/Addcontratoneupdate',
      '/psfcpresforenqpromocontratcontratdonationptwo',
      '/psfcpresforenqpromocontratcontratdonationptwoupdate',
      '/psfcpresforenqpromocontratcontratdonationpthree',
      '/psfcpresforenqpromocontratcontratdonationpthreeupdate',
      '/psfcpresforenqpromocontratcontratdonationpfour',
      '/psfcpresforenqpromocontratcontratdonationpfourupdate',
      '/psfcpresforenqpromocontratcontratdonationpfive',
      '/psfcpresforenqpromocontratcontratdonationpfiveupdate',
      '/psfcpresforenqpromocontratcontratdonationpsix',
      '/psfcpresforenqpromocontratcontratdonationpsixupdate',
      '/psfcpresforenqpromocontratcontratdonationpseven',
      '/psfcpresforenqpromocontratcontratdonationpsevenupdate',
      '/psfcpresforenqpromocontratcontratdonationpeight',
      '/psfcpresforenqpromocontratcontratdonationpeightupdate',
      '/psfcpresforenqpromocontratcontratdonationpnine',
      '/psfcpresforenqpromocontratcontratdonationpnineupdate',
      '/psfcpresforenqpromocontratcontratdonationpten',
      '/psfcpresforenqpromocontratcontratdonationptenupdate',
      '/psfcpresforlivrablescf',
      '/psfcpresforlivrablescla',
      '/rapport-deroulement',
      '/declarationouverture',
      '/psfcpresforenqcf',
      '/addcfinfo',
      '/demandeenqcf',
      '/infooptcf',
      '/editdemandeenqcf',
      '/editinfooptcf',
      '/addpvcl',
      '/addannexespvcl',
      '/cf4',
      '/addannoncepub',
      '/addannexesannoncepub',
      '/cf8',
      '/addpvpub',
      '/addannexespvpub',
      '/cf9',
      '/addcecpdc',
      '/editcecpdc',
      '/editannexescecpdc',
      '/addannexescecpdc',
      '/addcecpdc-dcf',
      '/editcecpdc-dcf',
      '/addannexescecpdc-dcf',
      '/editannexescecpdc-dcf',
      '/cf10',
      '/addvalidation',
      '/addvalidation-annonce',
      '/addannexesvalidation',
      '/addannexesvalidation-annonce',
      '/editvalidation-annonce',
      '/editannexesvalidation-annonce',
      '/cf11',
      '/addclP',
      '/addannexesclP',
      '/cf12',
      '/addcf19',
      '/cf19',
      '/addouverturepub',
      '/addannexesouverturepub',
      '/cf20',
      '/pub',
      '/miseenoeuvredesopcf',
      '/fichedemographiquecf',
      '/QuestionnaireCF',
      '/InfoOccuppantsParcelle',
      '/AutresDeclarationsCF',
      '/ListeDesServitudes',
      '/EtatDesDroitsDeProp',
      '/FicheLitigesCF',
      '/pvrdc',
      '/listepvrdc',
      '/SignatairesDesignationGestionnaire',
      '/GestionnaireCF',
      '/editcf',
      '/addficheidentification',
      '/consodispo/attestationformationaefj',
      '/consodispo/attestationformationaefc',
      '/dtv/historique-constitution',
      '/attestation-approbation-enquete-officielle',
      '/attestation-validation-enquete-fonciere',
    ].includes(pathname)
  ) {
    return <Navigate to="/psfcseconnecter" />;
  }
  return <Element />;
};
